/**
 * LogoMark — renders the original uploaded circle logo icon.
 * Kept as a component so we can swap the source in one place.
 *
 * Uses pointer-events: none so wrapping <Link> or <button> reliably receives clicks
 * (this fixes a subtle issue where SVG <title>/hit-testing could swallow the click).
 */
export default function LogoMark({ size = 44, className = "", title = "Physio Hyve Clinic" }) {
  return (
    <img
      src="/logo-icon.png"
      alt={title}
      width={size}
      height={size}
      draggable={false}
      className={`shrink-0 object-contain select-none pointer-events-none ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
